
    <template>
      <section class="doc-article monkey-view-doc">
        <h1>TimePicker 时间选择器</h1>
<p>选择时间，支持时、分、秒选择，支持时间的范围选择。</p>
<h2 id="dai-ma-shi-li" class="anchor-title">代码示例 <a class="header-anchor" href="#dai-ma-shi-li">#</a></h2>
<code-wrap id="JCYF">
                <template slot="description"><p>设置<code>type</code>类型为<code>time</code> <code>timerange</code>分别为时间单选和时间范围选择。</p>
<p>设置<code>placement</code>属性可以控制下拉框的位置，和tooltip组件一致。</p>
</template>
                <template slot="title">基础用法 <a href="#JCYF" data-title="基础用法">#</a></template>
                <template slot="source"><monkey-view-demo0 /></template>
                <template slot="highlight">
<p></p>
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;Row :gutter=&quot;16&quot;&gt;
        &lt;Col&gt;
            &lt;TimePicker placeholder=&quot;请选择时间&quot; clearable&gt;&lt;/TimePicker&gt;
        &lt;/Col&gt;
        &lt;Col&gt;
            &lt;TimePicker type=&quot;timerange&quot; placement=&quot;bottom-end&quot; placeholder=&quot;请选择时间范围&quot; clearable&gt;&lt;/TimePicker&gt;
        &lt;/Col&gt;
    &lt;/Row&gt;
&lt;/template&gt;
</code></pre></div></template></code-wrap>
<code-wrap id="SJGSH">
                <template slot="description"><p>设置<code>format</code>属性格式化时间。format会改变value的值。</p>
</template>
                <template slot="title">时间格式化 <a href="#SJGSH" data-title="时间格式化">#</a></template>
                <template slot="source"><monkey-view-demo1 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;Row :gutter=&quot;16&quot;&gt;
        &lt;Col&gt;
            &lt;TimePicker v-model=&quot;time1&quot; format=&quot;HH时mm分ss秒&quot; placeholder=&quot;请选择时间&quot;&gt;&lt;/TimePicker&gt;
        &lt;/Col&gt;
        &lt;Col&gt;
            &lt;TimePicker v-model=&quot;time2&quot; format=&quot;HH,mm,ss&quot; placeholder=&quot;请选择时间&quot;&gt;&lt;/TimePicker&gt;
        &lt;/Col&gt;
        &lt;Col&gt;
            &lt;TimePicker v-model=&quot;time3&quot; type=&quot;timerange&quot; format=&quot;HH时mm分ss秒&quot; placeholder=&quot;请选择时间范围&quot;&gt;&lt;/TimePicker&gt;
        &lt;/Col&gt;
    &lt;/Row&gt;
&lt;/template&gt;
&lt;script&gt;
    export default {
        data(){
            return {
                time1: '00:09:05',
                time2: '',
                time3: ['00:09:05', '00:09:04'],
            }
        }
    }
&lt;/script&gt;

</code></pre></div></template></code-wrap>
<code-wrap id="XZSF">
                <template slot="description"><p>设置<code>format</code>属性格式化时间。去掉秒。</p>
</template>
                <template slot="title">选择时分 <a href="#XZSF" data-title="选择时分">#</a></template>
                <template slot="source"><monkey-view-demo2 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;Row :gutter=&quot;16&quot;&gt;
        &lt;Col&gt;
            &lt;TimePicker format=&quot;HH:mm&quot; placeholder=&quot;请选择时间&quot;&gt;&lt;/TimePicker&gt;
        &lt;/Col&gt;
        &lt;Col&gt;
            &lt;TimePicker format=&quot;HH:mm&quot; type=&quot;timerange&quot; placeholder=&quot;请选择时间范围&quot;&gt;&lt;/TimePicker&gt;
        &lt;/Col&gt;
    &lt;/Row&gt;
&lt;/template&gt;
</code></pre></div></template></code-wrap>
<code-wrap id="BKXSJ">
                <template slot="description"><p>设置<code>disabledHours</code>属性设置不可选的小时。</p>
<p><code>disabledMinutes</code>设置不可选的分钟。</p>
<p><code>disabledSecond</code>设置不可选的秒。</p>
<p><code>hideDisabledOptions</code>设置隐藏disabled的项。</p>
</template>
                <template slot="title">不可选时间 <a href="#BKXSJ" data-title="不可选时间">#</a></template>
                <template slot="source"><monkey-view-demo3 /></template>
                <template slot="highlight">
<p></p>
<p></p>
<p></p>
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;Row :gutter=&quot;16&quot;&gt;
        &lt;Col&gt;
            &lt;TimePicker :disabledHours=&quot;[0,1,2]&quot; :disabledMinutes=&quot;[0,1,2]&quot; placeholder=&quot;请选择时间&quot;&gt;&lt;/TimePicker&gt;
        &lt;/Col&gt;
        &lt;Col&gt;
            &lt;TimePicker :disabledHours=&quot;[0,1,2]&quot; :disabledMinutes=&quot;[0,1,2]&quot; hideDisabledOptions placeholder=&quot;请选择时间&quot;&gt;&lt;/TimePicker&gt;
        &lt;/Col&gt;
        &lt;Col&gt;
            &lt;TimePicker type=&quot;timerange&quot; :disabledHours=&quot;[0,1,2]&quot; :disabledMinutes=&quot;[0,1,2]&quot; placeholder=&quot;请选择时间范围&quot;&gt;&lt;/TimePicker&gt;
        &lt;/Col&gt;
    &lt;/Row&gt;
&lt;/template&gt;
&lt;script&gt;
    export default {
        data(){
            return {
                shortcuts: [
                    {
                      text: '今天',
                      onClick(picker){
                          let date = new Date();
                          picker.setValue(date);
                      }
                    },
                    {
                      text: '昨天',
                      onClick(picker){
                          let date = new Date();
                          date.setDate(date.getDate() - 1);
                          picker.setValue(date);
                      }
                    },
                    {
                      text: '一周之前的某一天',
                      onClick(picker){
                          let date = new Date();
                          date.setDate(date.getDate() - 7);
                          picker.setValue(date);
                      }
                    }
                ],
                shortcutsrange: [
                    {
                      text: '最近一周',
                      onClick(picker){
                          let date1 = new Date();
                          let date2 = new Date();
                          date1.setDate(date1.getDate() - 7);
                          picker.setValue([date1, date2]);
                      }
                    },
                    {
                      text: '一个月',
                      onClick(picker){
                          let date1 = new Date();
                          let date2 = new Date();
                          date1.setDate(date1.getDate() - 30);
                          picker.setValue([date1, date2]);
                      }
                    },
                    {
                      text: '三个月',
                      onClick(picker){
                          let date1 = new Date();
                          let date2 = new Date();
                          date1.setDate(date1.getDate() - 90);
                          picker.setValue([date1, date2]);
                      }
                    }
                ],
            }
        }
    }
&lt;/script&gt;
</code></pre></div></template></code-wrap>
<code-wrap id="QRCZ">
                <template slot="description"><p>设置<code>confirm</code>属性可以展示确认和清除按钮，确认按钮不影响时间选择。</p>
</template>
                <template slot="title">确认操作 <a href="#QRCZ" data-title="确认操作">#</a></template>
                <template slot="source"><monkey-view-demo4 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;Row :gutter=&quot;16&quot;&gt;
        &lt;Col&gt;
            &lt;TimePicker confirm placeholder=&quot;请选择日期&quot;&gt;&lt;/TimePicker&gt;
        &lt;/Col&gt;
        &lt;Col&gt;
            &lt;TimePicker type=&quot;timerange&quot; confirm placeholder=&quot;请选择日期范围&quot;&gt;&lt;/TimePicker&gt;
        &lt;/Col&gt;
    &lt;/Row&gt;
&lt;/template&gt;
&lt;script&gt;
    export default {
        data(){
            return {
                
            }
        },
        methods: {
            
        }
    }
&lt;/script&gt;
</code></pre></div></template></code-wrap>
<code-wrap id="ZDHBKSR">
                <template slot="description"><p>设置<code>readonly</code>属性开启只读。只读时不能打开日期下拉框。</p>
<p>设置<code>editable</code>属性控制是否可输入。</p>
</template>
                <template slot="title">只读和不可输入 <a href="#ZDHBKSR" data-title="只读和不可输入">#</a></template>
                <template slot="source"><monkey-view-demo5 /></template>
                <template slot="highlight">
<p></p>
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;Row :gutter=&quot;16&quot;&gt;
        &lt;Col&gt;
            &lt;h4&gt;只读&lt;/h4&gt;
            &lt;TimePicker placeholder=&quot;请选择时间&quot; readonly&gt;&lt;/TimePicker&gt;
        &lt;/Col&gt;
        &lt;Col&gt;
            &lt;h4&gt;不可输入&lt;/h4&gt;
            &lt;TimePicker type=&quot;timerange&quot; placeholder=&quot;请选择时间范围&quot; :editable=&quot;false&quot;&gt;&lt;/TimePicker&gt;
        &lt;/Col&gt;
    &lt;/Row&gt;
&lt;/template&gt;
&lt;script&gt;
    export default {
        data(){
            return {
                
            }
        },
    }
&lt;/script&gt;
</code></pre></div></template></code-wrap>
<code-wrap id="JY">
                <template slot="description"><p>设置<code>disabled</code>属性禁用日期选择器。</p>
</template>
                <template slot="title">禁用 <a href="#JY" data-title="禁用">#</a></template>
                <template slot="source"><monkey-view-demo6 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;TimePicker placeholder=&quot;请选择时间&quot; disabled&gt;&lt;/TimePicker&gt;
&lt;/template&gt;
&lt;script&gt;
    export default {
        data(){
            return {
                
            }
        },
    }
&lt;/script&gt;
</code></pre></div></template></code-wrap>
<code-wrap id="ZDYCFQ">
                <template slot="description"><p>设置<code>disabled</code>属性禁用日期选择器。</p>
</template>
                <template slot="title">自定义触发器 <a href="#ZDYCFQ" data-title="自定义触发器">#</a></template>
                <template slot="source"><monkey-view-demo7 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;TimePicker placeholder=&quot;请选择时间&quot; :open=&quot;open&quot;&gt;
        &lt;Button type=&quot;text&quot; @click=&quot;open = !open&quot;&gt;触发时间框打开关闭&lt;/Button&gt;
    &lt;/TimePicker&gt;
&lt;/template&gt;
&lt;script&gt;
    export default {
        data(){
            return {
                open: false
            }
        },
    }
&lt;/script&gt;
</code></pre></div></template></code-wrap>
<code-wrap id="ZXSSJK">
                <template slot="description"><p>设置<code>only-show-pane</code>属性只显示日期框。</p>
</template>
                <template slot="title">只显示时间框 <a href="#ZXSSJK" data-title="只显示时间框">#</a></template>
                <template slot="source"><monkey-view-demo8 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;TimePicker v-model=&quot;time&quot; only-show-pane @change=&quot;handleChange&quot;&gt;
        &lt;template slot=&quot;paneFooter&quot;&gt;
            &lt;Button size=&quot;small&quot; @click=&quot;handleClear&quot;&gt;清除&lt;/Button&gt;
        &lt;/template&gt;
    &lt;/TimePicker&gt;
&lt;/template&gt;
&lt;script&gt;
    export default {
        data(){
            return {
                time: ''
            }
        },
        methods: {
            handleChange(value){
                this.$Message.info('selectd value is ' + value)
            },
            handleClear(){
                this.time = '';
            }   
        }
    }
&lt;/script&gt;
</code></pre></div></template></code-wrap>
<code-wrap id="CC">
                <template slot="description"><p>设置<code>size</code>属性控制尺寸大小，可选值 <code>mini</code> <code>small</code> <code>large</code>或者不设置。</p>
</template>
                <template slot="title">尺寸 <a href="#CC" data-title="尺寸">#</a></template>
                <template slot="source"><monkey-view-demo9 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;Row :gutter=&quot;16&quot;&gt;
        &lt;Col&gt;
            &lt;h4&gt;Mini&lt;/h4&gt;
            &lt;TimePicker placeholder=&quot;请选择时间&quot; size=&quot;mini&quot;&gt;&lt;/TimePicker&gt;
        &lt;/Col&gt;
        &lt;Col&gt;
            &lt;h4&gt;Small&lt;/h4&gt;
            &lt;TimePicker placeholder=&quot;请选择时间&quot; size=&quot;small&quot;&gt;&lt;/TimePicker&gt;
        &lt;/Col&gt;
        &lt;Col&gt;
            &lt;h4&gt;Default&lt;/h4&gt;
            &lt;TimePicker placeholder=&quot;请选择时间&quot;&gt;&lt;/TimePicker&gt;
        &lt;/Col&gt;
        &lt;Col&gt;
            &lt;h4&gt;Large&lt;/h4&gt;
            &lt;TimePicker placeholder=&quot;请选择时间&quot; size=&quot;large&quot;&gt;&lt;/TimePicker&gt;
        &lt;/Col&gt;
    &lt;/Row&gt;
&lt;/template&gt;
&lt;script&gt;
    export default {
        data(){
            return {
                
            }
        },
    }
&lt;/script&gt;
</code></pre></div></template></code-wrap>
<h2 id="api" class="anchor-title">API <a class="header-anchor" href="#api">#</a></h2>
<h3 id="timepicker-props" class="anchor-title">TimePicker props <a class="header-anchor" href="#timepicker-props">#</a></h3>
<table class="doc-table"><thead>
<tr>
<th>属性</th>
<th>类型</th>
<th>说明</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>type</td>
<td>String</td>
<td>设置时间选择器的类型，可选值 <code>time</code> <code>timerange</code></td>
<td>time</td>
</tr>
<tr>
<td>value</td>
<td>String, Array, Date, Number</td>
<td>绑定的值，可以使用v-model进行双向绑定，<code>range</code>模式下为Array类型, <code>Number</code>类型为时间戳</td>
<td>-</td>
</tr>
<tr>
<td>disabled</td>
<td>Boolean</td>
<td>禁用</td>
<td>-</td>
</tr>
<tr>
<td>disabledHours</td>
<td>Array</td>
<td>禁用的小时</td>
<td>[]</td>
</tr>
<tr>
<td>disabledMinutes</td>
<td>Array</td>
<td>禁用的分钟</td>
<td>[]</td>
</tr>
<tr>
<td>disabledSeconds</td>
<td>Array</td>
<td>禁用的秒</td>
<td>[]</td>
</tr>
<tr>
<td>hideDisabledOptions</td>
<td>Boolean</td>
<td>是否隐藏禁用的时间</td>
<td>-</td>
</tr>
<tr>
<td>confirm</td>
<td>Boolean</td>
<td>是否显示确认、清除按钮</td>
<td>-</td>
</tr>
<tr>
<td>readonly</td>
<td>Boolean</td>
<td>只读属性，只读时不能打开时间下拉框</td>
<td>-</td>
</tr>
<tr>
<td>placeholder</td>
<td>String</td>
<td>占位文本</td>
<td>-</td>
</tr>
<tr>
<td>size</td>
<td>String</td>
<td>尺寸，可选值 <code>mini</code> <code>small</code> <code>large</code>或者不设置</td>
<td>-</td>
</tr>
<tr>
<td>clearable</td>
<td>Boolean</td>
<td>显示清除图标</td>
<td>true</td>
</tr>
<tr>
<td>suffix</td>
<td>String</td>
<td>输入框尾部图标</td>
<td>time</td>
</tr>
<tr>
<td>prefix</td>
<td>String</td>
<td>输入框前置图标</td>
<td>-</td>
</tr>
<tr>
<td>transition</td>
<td>String</td>
<td>自定义时间下拉框的动画效果</td>
<td>slideUp</td>
</tr>
<tr>
<td>editable</td>
<td>Boolean</td>
<td>是否可以输入</td>
<td>true</td>
</tr>
<tr>
<td>placement</td>
<td>String</td>
<td>和<code>tooltip</code>一样</td>
<td>bottom-start</td>
</tr>
<tr>
<td>format</td>
<td>String</td>
<td>输入框展示时间的格式化，详细见<code>date-picker</code>组件的日期格式化说明</td>
<td>HH:mm:ss</td>
</tr>
<tr>
<td>value-format</td>
<td>String</td>
<td><code>v-model</code>绑定值时间的格式化，详细见<code>date-picker</code>组件的日期格式化说明</td>
<td>HH:mm:ss</td>
</tr>
<tr>
<td>open</td>
<td>Boolean</td>
<td>自定义控制打开关闭时间下拉框，此时选择器不会主动关闭。</td>
<td>-</td>
</tr>
<tr>
<td>separator</td>
<td>String</td>
<td>两个时间之间的分隔符</td>
<td>～</td>
</tr>
<tr>
<td>className</td>
<td>String</td>
<td>选择器的类名</td>
<td>-</td>
</tr>
<tr>
<td>dropdownClassName</td>
<td>String</td>
<td>选择器下拉框的类名</td>
<td>-</td>
</tr>
<tr>
<td>only-show-pane</td>
<td>Boolean</td>
<td>只显示时间框</td>
<td>-</td>
</tr>
<tr>
<td>renderHtml</td>
<td>HTMLElement, Boolean</td>
<td>定义时间下拉框渲染的位置，如果为<code>true</code>则渲染到body中，可以指定渲染的元素</td>
<td>false</td>
</tr>
</tbody>
</table>
<h3 id="timepicker-event" class="anchor-title">TimePicker event <a class="header-anchor" href="#timepicker-event">#</a></h3>
<table class="doc-table"><thead>
<tr>
<th>事件名</th>
<th>说明</th>
<th>返回值</th>
</tr>
</thead>
<tbody>
<tr>
<td>change</td>
<td>数据改变时触发，返回已经格式化的时间</td>
<td>time</td>
</tr>
<tr>
<td>clear</td>
<td>点击清空按钮和清除按钮时触发</td>
<td>-</td>
</tr>
<tr>
<td>click-outside</td>
<td>点击外部关闭下拉框时触发</td>
<td>event</td>
</tr>
</tbody>
</table>
<h3 id="timepicker-slot" class="anchor-title">TimePicker slot <a class="header-anchor" href="#timepicker-slot">#</a></h3>
<table class="doc-table"><thead>
<tr>
<th>名称</th>
<th>说明</th>
</tr>
</thead>
<tbody>
<tr>
<td>-</td>
<td>自定义触发器</td>
</tr>
<tr>
<td>paneFooter</td>
<td>自定义日期选择框底部内容</td>
</tr>
</tbody>
</table>
<h3 id="timepicker-methods" class="anchor-title">TimePicker methods <a class="header-anchor" href="#timepicker-methods">#</a></h3>
<table class="doc-table"><thead>
<tr>
<th>名称</th>
<th>说明</th>
<th>参数</th>
</tr>
</thead>
<tbody>
<tr>
<td>focus</td>
<td>主动使input获取焦点</td>
<td>-</td>
</tr>
<tr>
<td>blur</td>
<td>主动使input失去焦点</td>
<td>-</td>
</tr>
</tbody>
</table>

      </section>
    </template>
    <script>
      export default {
        name: 'component-doc',
        components: {
          "monkey-view-demo0": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('Row',{attrs:{"gutter":16}},[_c('Col',[_c('TimePicker',{attrs:{"placeholder":"请选择时间","clearable":""}})],1),_vm._v(" "),_c('Col',[_c('TimePicker',{attrs:{"type":"timerange","placement":"bottom-end","placeholder":"请选择时间范围","clearable":""}})],1)],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"monkey-view-demo1": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('Row',{attrs:{"gutter":16}},[_c('Col',[_c('TimePicker',{attrs:{"format":"HH时mm分ss秒","placeholder":"请选择时间"},model:{value:(_vm.time1),callback:function ($$v) {_vm.time1=$$v},expression:"time1"}})],1),_vm._v(" "),_c('Col',[_c('TimePicker',{attrs:{"format":"HH,mm,ss","placeholder":"请选择时间"},model:{value:(_vm.time2),callback:function ($$v) {_vm.time2=$$v},expression:"time2"}})],1),_vm._v(" "),_c('Col',[_c('TimePicker',{attrs:{"type":"timerange","format":"HH时mm分ss秒","placeholder":"请选择时间范围"},model:{value:(_vm.time3),callback:function ($$v) {_vm.time3=$$v},expression:"time3"}})],1)],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
        data(){
            return {
                time1: '00:09:05',
                time2: '',
                time3: ['00:09:05', '00:09:04'],
            }
        }
    }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"monkey-view-demo2": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('Row',{attrs:{"gutter":16}},[_c('Col',[_c('TimePicker',{attrs:{"format":"HH:mm","placeholder":"请选择时间"}})],1),_vm._v(" "),_c('Col',[_c('TimePicker',{attrs:{"format":"HH:mm","type":"timerange","placeholder":"请选择时间范围"}})],1)],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"monkey-view-demo3": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('Row',{attrs:{"gutter":16}},[_c('Col',[_c('TimePicker',{attrs:{"disabledHours":[0,1,2],"disabledMinutes":[0,1,2],"placeholder":"请选择时间"}})],1),_vm._v(" "),_c('Col',[_c('TimePicker',{attrs:{"disabledHours":[0,1,2],"disabledMinutes":[0,1,2],"hideDisabledOptions":"","placeholder":"请选择时间"}})],1),_vm._v(" "),_c('Col',[_c('TimePicker',{attrs:{"type":"timerange","disabledHours":[0,1,2],"disabledMinutes":[0,1,2],"placeholder":"请选择时间范围"}})],1)],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
        data(){
            return {
                shortcuts: [
                    {
                      text: '今天',
                      onClick(picker){
                          let date = new Date();
                          picker.setValue(date);
                      }
                    },
                    {
                      text: '昨天',
                      onClick(picker){
                          let date = new Date();
                          date.setDate(date.getDate() - 1);
                          picker.setValue(date);
                      }
                    },
                    {
                      text: '一周之前的某一天',
                      onClick(picker){
                          let date = new Date();
                          date.setDate(date.getDate() - 7);
                          picker.setValue(date);
                      }
                    }
                ],
                shortcutsrange: [
                    {
                      text: '最近一周',
                      onClick(picker){
                          let date1 = new Date();
                          let date2 = new Date();
                          date1.setDate(date1.getDate() - 7);
                          picker.setValue([date1, date2]);
                      }
                    },
                    {
                      text: '一个月',
                      onClick(picker){
                          let date1 = new Date();
                          let date2 = new Date();
                          date1.setDate(date1.getDate() - 30);
                          picker.setValue([date1, date2]);
                      }
                    },
                    {
                      text: '三个月',
                      onClick(picker){
                          let date1 = new Date();
                          let date2 = new Date();
                          date1.setDate(date1.getDate() - 90);
                          picker.setValue([date1, date2]);
                      }
                    }
                ],
            }
        }
    }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"monkey-view-demo4": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('Row',{attrs:{"gutter":16}},[_c('Col',[_c('TimePicker',{attrs:{"confirm":"","placeholder":"请选择日期"}})],1),_vm._v(" "),_c('Col',[_c('TimePicker',{attrs:{"type":"timerange","confirm":"","placeholder":"请选择日期范围"}})],1)],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
        data(){
            return {
                
            }
        },
        methods: {
            
        }
    }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"monkey-view-demo5": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('Row',{attrs:{"gutter":16}},[_c('Col',[_c('h4',[_vm._v("只读")]),_vm._v(" "),_c('TimePicker',{attrs:{"placeholder":"请选择时间","readonly":""}})],1),_vm._v(" "),_c('Col',[_c('h4',[_vm._v("不可输入")]),_vm._v(" "),_c('TimePicker',{attrs:{"type":"timerange","placeholder":"请选择时间范围","editable":false}})],1)],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
        data(){
            return {
                
            }
        },
    }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"monkey-view-demo6": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('TimePicker',{attrs:{"placeholder":"请选择时间","disabled":""}})]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
        data(){
            return {
                
            }
        },
    }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"monkey-view-demo7": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('TimePicker',{attrs:{"placeholder":"请选择时间","open":_vm.open}},[_c('Button',{attrs:{"type":"text"},on:{"click":function($event){_vm.open = !_vm.open}}},[_vm._v("触发时间框打开关闭")])],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
        data(){
            return {
                open: false
            }
        },
    }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"monkey-view-demo8": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('TimePicker',{attrs:{"only-show-pane":""},on:{"change":_vm.handleChange},model:{value:(_vm.time),callback:function ($$v) {_vm.time=$$v},expression:"time"}},[_c('template',{slot:"paneFooter"},[_c('Button',{attrs:{"size":"small"},on:{"click":_vm.handleClear}},[_vm._v("清除")])],1)],2)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
        data(){
            return {
                time: ''
            }
        },
        methods: {
            handleChange(value){
                this.$Message.info('selectd value is ' + value)
            },
            handleClear(){
                this.time = '';
            }   
        }
    }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"monkey-view-demo9": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('Row',{attrs:{"gutter":16}},[_c('Col',[_c('h4',[_vm._v("Mini")]),_vm._v(" "),_c('TimePicker',{attrs:{"placeholder":"请选择时间","size":"mini"}})],1),_vm._v(" "),_c('Col',[_c('h4',[_vm._v("Small")]),_vm._v(" "),_c('TimePicker',{attrs:{"placeholder":"请选择时间","size":"small"}})],1),_vm._v(" "),_c('Col',[_c('h4',[_vm._v("Default")]),_vm._v(" "),_c('TimePicker',{attrs:{"placeholder":"请选择时间"}})],1),_vm._v(" "),_c('Col',[_c('h4',[_vm._v("Large")]),_vm._v(" "),_c('TimePicker',{attrs:{"placeholder":"请选择时间","size":"large"}})],1)],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
        data(){
            return {
                
            }
        },
    }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
  